// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__vmKTl","wrapper":"PriceList_wrapper__uzLMA","pricing":"PriceList_pricing__WTT+l","footerStyle":"PriceList_footerStyle__YUHG5"};